export default {
  restricted: {
    title: "Accès restreint",
    description: "Vous devez être connecté pour accéder à cette page.",
    login: "Se connecter"
  },
  denied: {
    title: "Accès refusé",
    description: "Vous n'avez pas les permissions nécessaires pour accéder à cette page.",
    back: "Retour à l'accueil"
  },
  expired: {
    title: "Session expirée",
    description: "Votre session a expiré. Veuillez vous reconnecter.",
    login: "Se reconnecter"
  },
  invitation: {
    title: "Invitation requise",
    description: "Vous avez besoin d'une invitation pour accéder à cette ressource.",
    contact: "Contactez l'administrateur pour obtenir une invitation."
  },
  subscriptionRequired: {
    title: "Abonnement requis",
    description: "Cette fonctionnalité nécessite un abonnement actif.",
    upgrade: "Mettre à niveau"
  }
};

